import { render, staticRenderFns } from "./PostImageCropper.vue?vue&type=template&id=a47b0104"
import script from "./PostImageCropper.vue?vue&type=script&lang=ts"
export * from "./PostImageCropper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports